import React, { useState } from "react";
import { Button, Form, NavLink } from "react-bootstrap";
import { toast } from 'react-toastify';
import axios from "axios";
import Select from "react-select";
import Constants from "../../../frontLayout/Variables/Constants";
import COUNTRIES from "../../../frontLayout/Variables/countries";
import logo from "../../../assets/images/logo.png";
import google from "../../../assets/images/icons/google.svg";
import fb_icon from "../../../assets/images/icons/fb_icon.svg";
import { Link } from "react-router-dom";

const COUNTRY_MAP = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
const COUNTRY_CODE_ALIAS_MAP = COUNTRIES.reduce((acc, country) => {
  const code = String(country.code || "").toUpperCase();
  const name = String(country.name || "").toLowerCase();
  if (code) acc[code.toLowerCase()] = code;
  if (name) acc[name] = code;
  return acc;
}, {});

const resolveCountryCode = (value) => {
  const normalized = String(value || "").trim();
  if (!normalized) return "";
  return COUNTRY_CODE_ALIAS_MAP[normalized.toLowerCase()] || normalized.toUpperCase();
};

const resolveStateCode = (countryCode, value) => {
  const normalized = String(value || "").trim();
  if (!normalized) return "";

  const states = COUNTRY_MAP[countryCode]?.states || [];
  const matchedState = states.find(
    (state) =>
      state.code.toLowerCase() === normalized.toLowerCase() ||
      state.name.toLowerCase() === normalized.toLowerCase()
  );

  return matchedState?.code || normalized.toUpperCase();
};

function SignupComponent() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirm_password: '',
    // Optional address captured at signup (stored via useraddress/create after registration)
    address_name: "",
    country: "",
    address: "",
    city: "",
    state: "",
    postal_code: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const selectedCountryStates = COUNTRY_MAP[formData.country]?.states || [];
  const countryOptions = COUNTRIES.map((country) => ({
    value: country.code,
    label: `${country.name} (${country.code})`,
  }));
  const stateOptions = selectedCountryStates.map((state) => ({
    value: state.code,
    label: `${state.name} (${state.code})`,
  }));

  const validateName = () => {
    const name = formData.name;
    if (!name) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Name is Required!");
      return false;
    }
    if (!/^[a-zA-Z\s]*$/.test(name)) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Name must contain only letters and spaces");
      return false;
    }
    return true;
  };

  const validateEmail = () => {
    const email = formData.email;
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!email) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Email address is required");
      return false;
    }
    if (!emailPattern.test(email)) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Invalid email address");
      return false;
    }
    return true;
  };

  const validatePassword = () => {
    const phone = formData.password;

    if (!phone) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Phone number is required");
      return false;
    }



    return true;
  };

  const confirmPasswordValidation = () => {
    const { password, confirm_password } = formData;

    if (!confirm_password) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Confirm Phone is required");
      return false;
    }

    if (confirm_password !== password) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Phone numbers do not match");
      return false;
    }

    return true;
  };

  const validateAddressIfProvided = () => {
    const anyAddressValue = ["address_name", "country", "address", "city", "state", "postal_code"].some(
      (key) => String(formData?.[key] || "").trim() !== ""
    );

    if (!anyAddressValue) return true;

    const requiredKeys = ["address_name", "country", "address", "city", "postal_code"];
    const missing = requiredKeys.filter((key) => String(formData?.[key] || "").trim() === "");

    if (missing.length) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Please fill all required address fields (name, country, address, city, postal code).");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      if (
        validateName() &&
        validateEmail() &&
        validatePassword() &&
        confirmPasswordValidation() &&
        validateAddressIfProvided()
      ) {
        const payload = {
          name: formData.name,
          email: formData.email,
          password: formData.password,
        };
        const res = await axios.post(Constants.postUrls.signup, payload);
        if (res.data.status === "success") {

          toast.clearWaitingQueue();
          toast.dismiss();
          toast.success(res.data.message, {
            style: { backgroundColor: 'green', color: 'white' },
          });

          // Save token first, then try to create a default address (best-effort).
          localStorage.setItem("token", res.data.token);

          const anyAddressValue = ["address_name", "country", "address", "city", "state", "postal_code"].some(
            (key) => String(formData?.[key] || "").trim() !== ""
          );

          if (anyAddressValue) {
            const addressPayload = {
              address_name: formData.address_name,
              country: formData.country,
              address: formData.address,
              city: formData.city,
              state: formData.state,
              postal_code: formData.postal_code,
              is_default: "yes",
            };

            try {
              await axios.post(Constants.postUrls.addAddress, addressPayload, {
                headers: { Authorization: res.data.token },
              });
            } catch (addrErr) {
              toast.error("Signup succeeded, but address could not be saved. You can add it later from Address.");
              console.error(addrErr);
            }
          }

          setTimeout(() => {
            window.location.assign("/");
          }, 3000);
        } else {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error(res.data.message);
        }
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  return (
    <>
      <NavLink to="/" className="navbar-brand">
        <img loading="lazy" src={logo} alt="Logo" />
      </NavLink>
      <div className="d-flex align-items-center my-4">
        <h1 className="fs-36 fw-400 m-0">Welcome Back 👋</h1>
      </div>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4" controlId="formBasicName">
          <Form.Label className="fs-16 fw-400">Name</Form.Label>
          <Form.Control
            className="fs-16 fw-400"
            type="text"
            name="name"
            onChange={handleChange}
            value={formData.name}
            onBlur={validateName}
            placeholder="Enter Name"
          />
        </Form.Group>
        <Form.Group className="mb-4" controlId="formBasicEmail">
          <Form.Label className="fs-16 fw-400">Email</Form.Label>
          <Form.Control
            className="fs-16 fw-400"
            type="email"
            name="email"
            onChange={handleChange}
            value={formData.email}
            onBlur={validateEmail}
            placeholder="Example@email.com"
          />
        </Form.Group>

        <div className="mb-3">
          <h2 className="fs-16 fw-400 m-0">Address (optional)</h2>
        </div>

        <Form.Group className="mb-4" controlId="formAddressName">
          <Form.Label className="fs-16 fw-400">Address Name</Form.Label>
          <Form.Control
            className="fs-16 fw-400"
            type="text"
            name="address_name"
            onChange={handleChange}
            value={formData.address_name}
            placeholder="Home / Office"
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="formCountry">
          <Form.Label className="fs-16 fw-400">Country / Region</Form.Label>
          <Select
            options={countryOptions}
            value={countryOptions.find((option) => option.value === formData.country) || null}
            onChange={(option) => {
              const countryCode = resolveCountryCode(option?.value || "");
              setFormData((prevData) => ({
                ...prevData,
                country: countryCode,
                state: "",
              }));
            }}
            placeholder="Select Country / Region"
            isSearchable
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="formAddressLine">
          <Form.Label className="fs-16 fw-400">Address</Form.Label>
          <Form.Control
            className="fs-16 fw-400"
            type="text"
            name="address"
            onChange={handleChange}
            value={formData.address}
            placeholder="Street, building, apartment"
          />
        </Form.Group>

        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-4" controlId="formCity">
              <Form.Label className="fs-16 fw-400">City</Form.Label>
              <Form.Control
                className="fs-16 fw-400"
                type="text"
                name="city"
                onChange={handleChange}
                value={formData.city}
                placeholder="City"
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-4" controlId="formState">
              <Form.Label className="fs-16 fw-400">State</Form.Label>
              {selectedCountryStates.length > 0 ? (
                <Select
                  options={stateOptions}
                  value={stateOptions.find((option) => option.value === formData.state) || null}
                  onChange={(option) => {
                    setFormData((prevData) => ({
                      ...prevData,
                      state: option?.value || "",
                    }));
                  }}
                  placeholder="Select State / Province"
                  isSearchable
                />
              ) : (
                <Form.Control
                  className="fs-16 fw-400"
                  type="text"
                  name="state"
                  onChange={(e) => {
                    const stateCode = resolveStateCode(formData.country, e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      state: stateCode,
                    }));
                  }}
                  value={formData.state}
                  placeholder="State / Province / Region"
                />
              )}
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-4" controlId="formPostalCode">
              <Form.Label className="fs-16 fw-400">Postal Code</Form.Label>
              <Form.Control
                className="fs-16 fw-400"
                type="text"
                name="postal_code"
                onChange={handleChange}
                value={formData.postal_code}
                placeholder="Postal Code"
              />
            </Form.Group>
          </div>
        </div>

        <Form.Group className="mb-4" controlId="formBasicPassword">
          <Form.Label className="fs-16 fw-400">Phone</Form.Label>
          <Form.Control
            className="fs-16 fw-400"
            type="tel"
            name="password"
            value={formData.password}
            onChange={handleChange}
            onBlur={validatePassword}
            placeholder="Enter phone number"
          />

        </Form.Group>
        <Form.Group className="mb-4" controlId="formBasicConfirmPassword">
          <Form.Label className="fs-16 fw-400">Confirm Phone</Form.Label>
          <Form.Control
            className="fs-16 fw-400"
            type="tel"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
            onBlur={confirmPasswordValidation}
            placeholder="Confirm phone number"
          />
        </Form.Group>
        <div className="d-grid mb-4">
          <Button variant="warning" type="submit">Sign Up</Button>
        </div>
        <div className="divider_or">
          <span>or</span>
        </div>
        {/* <div className="d-grid gap-3 sign_with_google_fb">
          <Button className="fs-16" variant="" type="button">
            <img loading="lazy"  className="me-2" width="20" src={google} alt="Google" /> Sign in with Google
          </Button>
          <Button className="fs-16" variant="" type="button">
            <img loading="lazy"  className="me-2" width="20" src={fb_icon} alt="Facebook" /> Sign in with Facebook
          </Button>
        </div> */}
        <div className="text-center mt-4">
          <p className="fs-16 fw-400">Already have an account? <Link className="text_brand_sepia_color" to="/login">Sign In</Link></p>

        </div>
      </Form>
    </>
  );
}

export default SignupComponent;
